export enum UserDefinedTaskTypes {
  Meeting = "meeting",
  Lead_follow_up = "lead follow up",
  Knowledge = "knowledge",
  Other = "other",
}

export enum SystemTaskTypes {
  Meeting_subordinate = "meeting_subordinate",
}

export const TaskTypes = [
  ...Object.values(UserDefinedTaskTypes),
  ...Object.values(SystemTaskTypes),
];

export enum TaskStatuses {
  Open = "open",
  Completed = "completed",
  Overdue = "overdue",
  Archived = "Archived",
}

export enum TaskStatusesBackend {
  pending = "pending",
  completed = "completed",
  archived = "archived",
}

export enum TaskTabs {
  all = "all",
  today = "today",
  overdue = "overdue",
  upcoming = "upcoming",
  completed = "completed",
  archived = "archived",
}

export enum LinkToOptions {
  LEAD = "Lead",
  PROPERTY = "Property",
}
